document.addEventListener('DOMContentLoaded', function() {
  initFeatureCards();
  initOfferingsTabs();
  initTestsTabs();
  initFaqAccordion();
  initShowMoreTests();
  initTrialModal();
  initSmoothScroll();
  initViewSyllabus();
  initContactForm();
});

function initFeatureCards() {
  const cards = document.querySelectorAll('.tb-feature-card');
  
  cards.forEach(function(card) {
    const header = card.querySelector('.tb-feature-card__header');
    if (!header) return;
    
    header.addEventListener('click', function() {
      const isOpen = card.classList.contains('is-open');
      
      cards.forEach(function(c) {
        c.classList.remove('is-open');
      });
      
      if (!isOpen) {
        card.classList.add('is-open');
      }
    });
  });
}

function initOfferingsTabs() {
  const tabs = document.querySelectorAll('.tb-offerings__tab');
  const panels = document.querySelectorAll('.tb-offerings__panel');
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const targetPanel = tab.dataset.tab;
      
      tabs.forEach(function(t) {
        t.classList.remove('tb-offerings__tab--active');
      });
      tab.classList.add('tb-offerings__tab--active');
      
      panels.forEach(function(panel) {
        panel.classList.remove('tb-offerings__panel--active');
        if (panel.dataset.panel === targetPanel) {
          panel.classList.add('tb-offerings__panel--active');
        }
      });
    });
  });
}

function initTestsTabs() {
  const tabs = document.querySelectorAll('.tb-tests__tab');
  const upcomingPanel = document.getElementById('upcomingTestsPanel');
  const livePanel = document.getElementById('liveTestsPanel');
  
  if (!tabs.length) return;
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const targetTab = tab.dataset.testtab;
      
      tabs.forEach(function(t) {
        t.classList.remove('tb-tests__tab--active');
      });
      tab.classList.add('tb-tests__tab--active');
      
      if (targetTab === 'upcoming') {
        if (upcomingPanel) upcomingPanel.style.display = 'block';
        if (livePanel) livePanel.style.display = 'none';
      } else if (targetTab === 'live') {
        if (upcomingPanel) upcomingPanel.style.display = 'none';
        if (livePanel) livePanel.style.display = 'block';
      }
    });
  });
}

function initFaqAccordion() {
  const faqItems = document.querySelectorAll('.tb-faq-item');
  
  faqItems.forEach(function(item) {
    const question = item.querySelector('.tb-faq-item__question');
    if (!question) return;
    
    question.addEventListener('click', function() {
      const isOpen = item.classList.contains('is-open');
      const expanded = question.getAttribute('aria-expanded') === 'true';
      
      faqItems.forEach(function(i) {
        i.classList.remove('is-open');
        const btn = i.querySelector('.tb-faq-item__question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      
      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initShowMoreTests() {
  const showMoreBtn = document.getElementById('showMoreTests');
  const hiddenTests = document.getElementById('testsHidden');
  const testsList = document.getElementById('testsList');
  
  if (!showMoreBtn || !hiddenTests || !testsList) return;
  
  let isExpanded = false;
  let originalHiddenContent = hiddenTests.innerHTML;
  
  showMoreBtn.addEventListener('click', function() {
    if (!isExpanded) {
      // Show more
      hiddenTests.style.display = 'flex';
      hiddenTests.style.flexDirection = 'column';
      hiddenTests.style.gap = '0.75rem';
      showMoreBtn.textContent = 'Show Less';
      isExpanded = true;
    } else {
      // Show less
      hiddenTests.style.display = 'none';
      showMoreBtn.textContent = 'Show More';
      isExpanded = false;
    }
  });
}

function initTrialModal() {
  const modal = document.getElementById('trialModal');
  if (!modal) return;
  
  const openBtns = document.querySelectorAll('[data-open-trial-modal]');
  const closeBtns = modal.querySelectorAll('[data-close-modal]');
  const form = modal.querySelector('.tb-modal__form');
  
  openBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });
  
  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });
  
  // Handle form submission
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const name = formData.get('name');
      const phone = formData.get('phone');
      const email = formData.get('email');
      const countryCode = formData.get('country_code') || '+91';
      
      // Submit to HubSpot
      submitToHubSpot({
        name: name,
        phone: countryCode + phone,
        email: email,
        source: 'Free Trial Modal',
        product: 'NEET 2027 - Target AIIMS Batch'
      }).then(function() {
        alert('Thank you! We will contact you shortly.');
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        form.reset();
      }).catch(function(err) {
        console.error('Form submission error:', err);
        alert('Something went wrong. Please try again or call us at +91-8527521718');
      });
    });
  }
}

function initSmoothScroll() {
  const tabs = document.querySelectorAll('.tb-tab');
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const targetId = tab.dataset.target;
      const targetSection = document.getElementById(targetId);
      
      if (targetSection) {
        tabs.forEach(function(t) {
          t.classList.remove('tb-tab--active');
        });
        tab.classList.add('tb-tab--active');
        
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

function initViewSyllabus() {
  const syllabusButtons = document.querySelectorAll('.tb-view-syllabus-btn');
  
  syllabusButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const testItem = btn.closest('.tb-test-item');
      if (!testItem) return;
      
      const syllabusContent = testItem.querySelector('.tb-test-item__syllabus');
      if (!syllabusContent) return;
      
      const isOpen = syllabusContent.classList.contains('is-open');
      
      // Close all other syllabus panels
      document.querySelectorAll('.tb-test-item__syllabus').forEach(function(s) {
        s.classList.remove('is-open');
      });
      
      if (!isOpen) {
        syllabusContent.classList.add('is-open');
        btn.textContent = 'Hide Syllabus';
      } else {
        btn.textContent = 'View Syllabus';
      }
    });
  });
}

function initContactForm() {
  const form = document.querySelector('.tb-consultation__form');
  if (!form) return;
  
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const formData = new FormData(form);
    const name = formData.get('name');
    const phone = formData.get('phone');
    const studentClass = formData.get('class');
    
    if (!name || !phone || !studentClass) {
      alert('Please fill all fields');
      return;
    }
    
    // Submit to HubSpot
    submitToHubSpot({
      name: name,
      phone: '+91' + phone,
      class: studentClass,
      source: 'Product Page Contact Form',
      product: 'NEET 2027 - Target AIIMS Batch'
    }).then(function() {
      alert('Thank you! Our counselor will contact you shortly.');
      form.reset();
    }).catch(function(err) {
      console.error('Form submission error:', err);
      alert('Something went wrong. Please call us at +91-8527521718');
    });
  });
}

function submitToHubSpot(data) {
  // HubSpot Forms API - Portal ID from NEETprep
  const portalId = '3929126';
  const formGuid = 'consultation-form'; // This would need to be the actual form GUID
  
  // For now, we'll use a simple approach that opens WhatsApp
  // Since we don't have direct HubSpot form access, redirect to WhatsApp
  const message = encodeURIComponent(
    'Hi! I am ' + data.name + 
    '. My phone: ' + data.phone + 
    (data.class ? '. Class: ' + data.class : '') +
    (data.email ? '. Email: ' + data.email : '') +
    '. I am interested in ' + data.product
  );
  
  return new Promise(function(resolve, reject) {
    try {
      // Open WhatsApp with pre-filled message
      window.open('https://api.whatsapp.com/send?phone=917835083692&text=' + message, '_blank');
      resolve();
    } catch (err) {
      reject(err);
    }
  });
}
